import styled from 'styled-components/macro';

export const ErrorMessage = styled.span`
  color: ${({ theme }) => theme.colors.text.alert};
  font-size: ${({ theme }) => theme.fonts.fontSize.ft14};
  margin-top: ${({ theme }) => theme.spacing.sp4};
  display: block;
`;
